<template>
  <div class="app-container">
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>

        <div style="padding-top: 20px">
          <el-select v-model="curSuggestionOption" clearable @change="curFilterOptionChange">
            <el-option v-for="item in suggestionOptions" :value="item.value" :key="item.value"
                       :label="item.label"></el-option>
          </el-select>

          <el-select style="padding-left: 20px" v-model="curShieldOption" clearable @change="curFilterOptionChange">
            <el-option v-for="item in shieldOptions" :value="item.value" :key="item.value"
                       :label="item.label"></el-option>
          </el-select>

          <el-select style="padding-left: 20px" v-model="curAuditOption" clearable @change="curFilterOptionChange">
            <el-option v-for="item in auditOptions" :value="item.value" :key="item.value"
                       :label="item.label"></el-option>
          </el-select>
        </div>

      </div>
    </div>
    <el-table ref="tableRef" v-loading="loading" :data="dataList" border stripe class="data-table"
              :header-cell-style="{ background: '#F5F7FA' }">
      <el-table-column
          label="ID"
          prop="contentSecureID"
          align="center"
      ></el-table-column>
      <el-table-column label="资源" prop="originUrl" align="center">
        <template #default="scope">
          <div v-if="type === 0 " style="width: 100px; height: 100px;">
            <el-image
                style="width: 100px; height: 100px;"
                fit="scale-down"
                :src="getCloudUrl(scope.row.originUrl)"
                lazy
                :preview-src-list="[getCloudUrl(scope.row.originUrl)]"
                hide-on-click-modal="true"
            ></el-image>
          </div>
          <div v-else-if="type === 1">
            <div style="width: 100px; height: 100px;position: relative; display: flex;justify-content: center;">
              <el-image
                  fit="scale-down"
                  :src="getCloudUrl(scope.row.relativeUrl)"
                  :preview-src-list="[getCloudUrl(scope.row.relativeUrl)]"
                  :hide-on-click-modal="true"
              ></el-image>
              <i class="el-icon-video-play"
                 style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: aliceblue;"
                 @click.stop="previewVideo(scope.row)"></i>
            </div>

          </div>
          <div v-else-if="type === 2">
            {{ getDisplayText(scope.row) }}
          </div>

        </template>
      </el-table-column>
      <el-table-column label="资源类型" prop="resourceType" align="center">
        <template #default="scope">
          {{ scope.row.resourceType | contentSecurityResourceTypeTransform }}
        </template>
      </el-table-column>
      <el-table-column
          label="识别类型"
          prop="resultLabel"
          align="center"
      >
        <template #default="scope">
          {{ scope.row.resultLabel | contentSecurityResultLabelTransform }}
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="概率" align="center">
        <template #default="scope">
          {{ getDisplayRate(scope.row.rate) }}
        </template>
      </el-table-column>

      <el-table-column label="审核状态" prop="isShield" align="center">
        <template #default="scope">
          <el-tag
              :type="scope.row.isAudited === true ? 'info' : 'primary'"
              size="small"
          >{{ scope.row.isAudited === true ? "已审核" : "未审核" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="检测时间" align="center">
        <template #default="scope">
          {{ scope.row.pornTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="删除时间" align="center">
        <template #default="scope">
          {{ scope.row.deleteTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="建议操作" prop="suggestion" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.suggestion" :type="getSuggestionType(scope.row)">{{
              scope.row.suggestion | contentSecuritySuggestionTransform
            }}
          </el-tag>

        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="300">
        <template #default="scope">
          <el-button :type="scope.row.isShield ?'warning' : 'danger' " @click="handleAuditContentSecurity(scope.row)">
            {{ scope.row.isShield ? '恢复正常' : '屏蔽资源' }}
          </el-button>
          <el-button
              :type="scope.row.isDeleted ? 'warning' : 'danger'"
              size="small"
              @click="handleDeleteContentSecurity(scope.row)"
          >{{ scope.row.isDeleted ? '恢复' : '删除' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页 -->
    <el-pagination background :total="totalCount"
                   :page-size="pageSize" :current-page="currentPage"
                   @current-change="curPageChange"/>

    <el-dialog :visible.sync="previewVideoDlg" width="60%" :destroy-on-close="true">
      <tx-video-player style="height: 60vh" :video-url="previewVideoUrl"></tx-video-player>
    </el-dialog>

  </div>
</template>

<script>
import {
  getContentSecureRecordList, secureRecordDeleteOrBack, auditContentSecureStatus
} from "@/api/system/contentSecurity/AdminContentSecure";
import {handleRes} from "@/utils/handleRes";
import {getCloudUrl} from "@/utils/urlutil";
import {isVaild} from "@/utils/validate";
import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import {printObj} from "@/utils/debug";

export default {
  name: "picSecurity",
  components: {TxVideoPlayer},
  props: {
    type: {
      Number
    }
  },
  data() {
    return {
      loading: "false",
      searchValue: "", // 搜索内容
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      dataList: [],
      suggestionOptions: [
        {
          value: "pass",
          label: "正常",
        },
        {
          value: "review",
          label: "疑似",
        },
        {
          value: "block",
          label: "违规",
        },
      ],
      curSuggestionOption: "",
      shieldOptions: [
        {
          value: true,
          label: "已屏蔽",
        },
        {
          value: false,
          label: "未屏蔽",
        }
      ],
      curShieldOption: "",
      auditOptions: [
        {
          value: true,
          label: "已审核",
        },
        {
          value: false,
          label: "未审核",
        }
      ],
      curAuditOption: "",
      previewVideoDlg: false,
      previewVideoUrl: ""
    }
  },
  created() {
    this.getContentRecordList()
  },
  methods: {
    getCloudUrl(path) {
      return getCloudUrl(path);
    },
    curPageChange(curPage) {
      this.currentPage = curPage
      this.getContentRecordList()
    },
    refreshList() {
      this.currentPage = 1
      this.getContentRecordList()
    },
    search() {
      this.refreshList()
    },
    curFilterOptionChange() {
      this.refreshList()
    },
    previewVideo(entity) {
      printObj(entity)
      this.previewVideoUrl = this.getCloudUrl(entity.originUrl)
      this.previewVideoDlg = true
    },
    getDisplayRate(rate) {
      if (isVaild(rate)) {
        return `${rate}%`
      }
      return "-"
    },
    getDisplayText(entity) {
      try {
        let field = entity.relativeField
        return entity.resourceObj[field] || entity.resourceObj[field.substring(0, 1).toLowerCase() + field.substring(1)]
      }catch (e) {

      }
      return ""
    },
    /**
     * 操作建议tag的type
     * @param entity
     */
    getSuggestionType(entity) {
      switch (entity.suggestion) {
        case 'pass':
          return 'info'
        case 'review':
          return 'warning'
        case 'block':
          return 'danger'
      }
      return 'primary'
    },
    getContentRecordList() {
      this.loading = true;
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        keyWord: this.searchValue,
        sortName: "",
        sortOrder: "",
        where: [{
          "field": "contentType",
          "value": this.type,
          "op": "equal"
        }]
      }
      //建议
      if (isVaild(this.curSuggestionOption)) {
        params.where.push({
          "field": "suggestion",
          "value": `'${this.curSuggestionOption}'`,
          "op": "equal"
        })
      }
      //屏蔽状态
      if (isVaild(this.curShieldOption)) {
        params.where.push({
          "field": "isShield",
          "value": this.curShieldOption,
          "op": "equal"
        })
      }
      //审核状态
      if (isVaild(this.curAuditOption)) {
        params.where.push({
          "field": "isAudited",
          "value": this.curAuditOption,
          "op": "equal"
        })
      }
      getContentSecureRecordList(params).then(res => {
        handleRes(res, () => {
          this.totalCount = res.data.total
          this.dataList = res.data.rows
        })
        this.utils.stopLoading(this)
      })
    },
    /**
     * 删除/恢复
     * @param entity
     */
    handleDeleteContentSecurity(entity) {
      secureRecordDeleteOrBack({
        contentSecureId: entity.contentSecureID
      }).then(res => {
        handleRes(res, () => {
          this.getContentRecordList()
        })
      })
    },
    async handleAuditContentSecurity(entity) {
      var inputRemark = null;
      if (!entity.isShield) {
        inputRemark = (await this.$prompt('请输入屏蔽原因')).value
      }
      auditContentSecureStatus({
        contentSecureId: entity.contentSecureID,
        operateStatus: entity.isShield ? 0 : 1,
        remark: inputRemark
      }).then(res => {
        handleRes(res, () => {
          this.getContentRecordList()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>